module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-8 col-md-12"
  }, [_c('calendar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('notifications')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fdd6be6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adminHome/adminHome.vue
// module id = 482
// module chunks = 1